const trackingUtils = require('../utils/tracking.utils');
import {dispatch} from 'od-modules/secure_store/store';
import {saveShoppingCartAndExecuteCallback} from 'od-modules/secure_store/reducers/asyncActionCreators';
const actions = require('../../modules/secure_store/actions');
const CART_STATUS = require('../utils/cart_status');
const {fareRulesManager, fareRuleEvents} = require('od-modules/fare_rules_manager');
const AncillariesShoppingCart = require('od-modules/cart/cart');
const smartFunnel = require('od-modules/smart_funnel');


const FLIGHT_SUMMARY_PAGE = 'flightsummary';
const FLIGHT_SUMMARY_META_PAGE = 'checkout_flight_summary_meta';
const META_FLOW_PAGES = [FLIGHT_SUMMARY_PAGE, FLIGHT_SUMMARY_META_PAGE];
const MOBILE_FLOW = 'mobile';
const TICKETS = 'TICKETS';
const META_ERROR_MESSAGE = 'Meta Broken Flow';
export default Odigeo.Model.extend({
    connect: true,
    selectionAccommodationProductErrorMessage: 'INT-003',
    specifiedAccommodationKeyDifferentFromPreviouslySelectedCode: 'ERR-011',
    selectionItineraryProductErrorMessage: 'SELECTION_ITINERARY_PRODUCT_ERROR',
    isEmptyData: true,
    lastShoppingCart: null,
    flightDetail: null,
    dataURL: 'createshoppingcart',
    metaURL: 'meta/createshoppingcart',
    data: {},
    typeOfCart: null,
    cartStatus: CART_STATUS.NOT_CREATED,
    continueWithFlight: false,
    continueFromSummary: false,
    url() {
        const url = this.shouldUseMetaEndpoint() ? this.metaURL : this.dataURL;
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(url);
    },

    getBookedFlight(data, callbackFnc = () => {}) {
        if (typeof this.lastShoppingCart === 'object'
            && !this.isEmptyData) {
            this.cancelBookedFlight();
        }
        this.isEmptyData = false;
        this.cartStatus = CART_STATUS.CREATING;
        this.lastShoppingCart = this.clear().save(data, {
            success: Odigeo._.bind(this.requestSuccessHandler(callbackFnc), this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        });
        Odigeo.trigger(this.widget.id + ':bookRequestPerformed');
    },

    cancelBookedFlight() {
        if (this.lastShoppingCart) {
            this.isEmptyData = true;
            this.lastShoppingCart.abort();
            this.lastShoppingCart = null;
            this.cartStatus = CART_STATUS.NOT_CREATED;
            return this.lastShoppingCart;
        }
    },

    executeBookRequestPerformeed() {
        Odigeo.trigger(this.widget.id + ':bookRequestPerformed');
    },

    getShoppingCartStatus() {
        return this.cartStatus;
    },

    isShoppingCartStatusFailed() {
        return this.cartStatus === CART_STATUS.FAILED;
    },

    requestSuccessHandler(callbackFnc = () => {}) {
        return (model, msg) => {
            const totalPrice = model.attributes.price;
            const exceededMaxThreshold = Odigeo._.get(msg, 'repricing.exceededMaxThreshold') || false;
            this.storeInAncillariesShoppingCart();
            Odigeo.Session.set('bookingId', msg.bookingId);
            if (msg.errors) {
                this.processErrorsInCreateShoppingCart(msg.errors);
            } else if (JSON.parse(exceededMaxThreshold)) {
                Odigeo.trigger(this.widget.id + ':requestCompletedWithExpensiveRepricing');
                Odigeo.trigger(this.widget.id + ':requestCompletedWithCheapRepricing', totalPrice, msg.repricing);
                Odigeo.Session.set('isPaxRepricingApplied', true);
                Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
            } else {
                dispatch({type: actions.SET_SHOPPING_CART, entry: msg.shoppingCartDTO});
                dispatch({type: actions.SET_REPRICING_LOG, entry: msg.repricing});
                if (Odigeo.AB.sidebarRevamp) {
                    dispatch({type: actions.SET_PRIME_MEMBER_SELECTED, entry: {
                        isSubscriptionAdded: Odigeo.Membership.isMembershipProductEnabled && !this.get('priceWithoutDiscountSelected'),
                    }, merge: true});
                }
                Odigeo.Utils.sessionTimer.reset();

                Odigeo.trigger(this.widget.id + ':setProductNameInSession', msg.transportType);
                if ((this.typeOfCart !== 'preShoppingCart' || this.get('continueWithFlight')) ||
                    (this.get('continueFromSummary') && this.typeOfCart === 'preShoppingCart')) {
                    callbackFnc();
                    this.shoppingAlreadyCreated(msg);
                }
                if (Odigeo.AB.isSummaryContinueButtonLoading) {
                    Odigeo.trigger(this.widget.id + ':shoppingCartSuccessfullyCreated');
                }
                this.cartStatus = CART_STATUS.CREATED;
                this.typeOfCart = null;
            }

            this.updateSearchIDInSession(msg);
        };
    },

    processErrorsInCreateShoppingCart(errors) {
        let [error] = errors;
        error = this.isNotDefaultBrokenFlowError(error) ? error : {message: '', code: 'CREATE_SHOPPING_CART_OK_BROKEN_FLOW_COUNTER'};
        Odigeo.trigger('frontend-shell:errorPreCreateShoppingCart', error);
        this.manageCreateShoppingCartError(error);
        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
    },
    isNotDefaultBrokenFlowError(error) {
        return this.isExpirationError(error)
        || this.isPreCreateShoppingCartError(error)
        || this.isAccommodationError(error)
        || this.isMetaError(error);
    },
    isPreCreateShoppingCartError(error) {
        return error.code === 'PRECREATE_SHOPPING_CART_ERROR';
    },
    isExpirationError(error) {
        return error.code === 'SESSION_EXPIRED_ERROR' || error.code === 'SEARCH_EXPIRED_ERROR';
    },
    isMetaError(error) {
        return error.message.includes(META_ERROR_MESSAGE) && Odigeo.AB.isMetaSelectionEnabled;
    },
    isAccommodationError(error) {
        const isAccommodationKeyError = Odigeo.Utils.startsWith(error.message, this.specifiedAccommodationKeyDifferentFromPreviouslySelectedCode)
            && !error.message.includes(error.message, this.selectionItineraryProductErrorMessage);
        const isInternalErrorNotMeta = Odigeo.Utils.startsWith(error.message, this.selectionAccommodationProductErrorMessage)
            && !this.isMetaError(error);
        return isInternalErrorNotMeta || isAccommodationKeyError;
    },
    manageCreateShoppingCartError(error) {
        if (this.isExpirationError(error)) {
            this.manageSearchExpiredError();
        } else if (this.isPreCreateShoppingCartError(error)) {
            this.managePreCreateShoppingCartError(error);
        } else if (this.isAccommodationError(error)) {
            this.manageAccommodationError();
        } else if (this.isMetaError(error)) {
            this.manageMetaError();
        } else {
            this.manageDefaultError();
        }
    },
    manageMetaError() {
        this.cartStatus = CART_STATUS.FAILED;
    },
    manageDefaultError() {
        Odigeo.trigger(this.widget.id + ':brokenFlowError');
        Odigeo.UIElements.showBrokenFlowError();
    },
    manageAccommodationError() {
        Odigeo.trigger(this.widget.id + ':selectionAccommodationProductError', {
            accommodationDealKey: this.widget.model.get('accommodationDealKey'),
            roomGroupDealKey: this.widget.model.get('roomGroupDealKey'),
        });
    },
    manageSearchExpiredError() {
        Odigeo.trigger(this.widget.id + ':searchExpiredError');
        Odigeo.UIElements.showSearchExpiredError();
    },
    managePreCreateShoppingCartError(error) {
        this.cartStatus = CART_STATUS.FAILED;
        if (Odigeo.AB.isSummaryContinueButtonLoading) {
            Odigeo.trigger(`${this.widget.id}:shoppingCartFailed`);
        } else if (this.get('continueWithFlight')) {
            this.handleBrokenFlowError(error);
        }
    },
    updateSearchIDInSession(msg) {
        if (Odigeo.SessionScope.isMeta && Odigeo.SessionScope.flow === MOBILE_FLOW && msg.searchId && Odigeo.AB.isTouchpointForMetas) {
            const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
            flightSelectionData.data.searchId = msg.searchId;
            Odigeo.Session.set('flightSelectionData', JSON.stringify(flightSelectionData));
        }
    },

    handleBrokenFlowError(error = {}) {
        Odigeo.trigger(`${this.widget.id}:brokenFlowError`);
        Odigeo.AB.isErrorFlightSelection ? Odigeo.UIElements.showSelectionError(error) : Odigeo.UIElements.showBrokenFlowError();
        trackingUtils.trackPage(Odigeo.History.getPageNameFromFragment(), {
            funnel: true,
            error: {type: 'default', message: 'precreate_shopping_cart_error'},
        });
    },

    shoppingAlreadyCreated(msg) {
        const fnc = (msg) ? Odigeo._.omit(msg, 'errors') : {};
        const shoppingCartFromModel = this.get('shoppingCartDTO') || {};
        const shoppingCart = msg && msg.shoppingCartDTO || shoppingCartFromModel || {};
        this.flightDetail = null;
        const executeFareRules = () => {
            fareRulesManager.then((action = fareRuleEvents.GO_TO_PAX) => {
                this.storeInAncillariesShoppingCart();
                const callback = () => Odigeo.trigger(this.widget.id + `:${action}`, fnc, shoppingCart);
                dispatch(saveShoppingCartAndExecuteCallback(shoppingCart, callback));
            });
        };

        if (shoppingCart.bookingId && smartFunnel.isSmartFunnelEnabled()) {
            smartFunnel.fetchAncillariesToSkip(shoppingCart.bookingId).catch(() => {
                // it is ok to fail silently here
            }).then(() => {
                return smartFunnel.fetchNextItineraryFunnelPage(shoppingCart.bookingId);
            }).then((nextPageUrl) => {
                const callback = () => Odigeo.Router.navigate(nextPageUrl.slice(0, -1));
                return saveShoppingCartAndExecuteCallback(shoppingCart, callback);
            }).catch(executeFareRules);
        } else {
            executeFareRules();
        }
    },

    requestErrorHandler(model, xhr) {
        if (xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors.length > 0) {
            this.processErrorsInCreateShoppingCart(xhr.responseJSON.errors);
        } else {
            if (!this.isEmptyData) {
                Odigeo.trigger(this.widget.id + ':bookRequestError', xhr);
                this.isEmptyData = true;
                this.flightDetail = null;
                this.cartStatus = CART_STATUS.NOT_CREATED;
                Odigeo.UIElements.showBrokenFlowError();
            }
        }
    },

    isSameFlight(data) {
        return (JSON.stringify({
            fareItineraryKey: data.fareItineraryKey,
            flightNumbers: data.flightNumbers,
            segmentKeys: data.segmentKeys,
        }) === JSON.stringify(this.flightDetail));
    },

    shouldUseMetaEndpoint() {
        const isMetaPage = META_FLOW_PAGES.includes(Odigeo.History.getPageNameFromFragment());
        return Odigeo.AB.isPreCreateShoppingCartMeta && isMetaPage;
    },

    storeInAncillariesShoppingCart() {
        AncillariesShoppingCart.setBookingId(this.get('bookingId'));
        AncillariesShoppingCart.addProduct({
            name: TICKETS,
            id: TICKETS,
            policy: TICKETS,
            category: TICKETS,
            concept: TICKETS,
            price: {
                total: this.get('price'),
            },
        });
    },
});
